export default "<div [innerHTML] = \"html\" class=\"thankyou\"></div>\n"